module.exports = __webpack_public_path__ + "img/angle-left-solid.2f2e6dab.svg";